import CurrencyHelper from '../../../helpers/currencyHelper';
import { ValueFormatterType } from '../types';

export function formatValue(value: number, type: ValueFormatterType, currency?: string): string {
  if (type === 'currency') {
    return CurrencyHelper.formatCurrency(CurrencyHelper.roundToDecimal(value || 0, 0), currency || 'aud');
  }
  if (type === 'integer') {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(Math.round(value || 0));
  }
  // decimal
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 2 }).format(value || 0);
}
